/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { buttonVariants } from '@/design-system';

/*
 * The full-page status layout shared by the access page (401/403) and the 404 page: a status
 * disc, a 24/400 title, one short line of body and the action row, centred on the page.
 */

/** The centred page column, filling the area it is rendered in (the shell's content area). */
export const STATUS_PAGE =
  'flex h-full flex-col items-center justify-center gap-4 px-6 text-center';

/** The same column on a page rendered without the shell: it fills the viewport itself. */
export const STATUS_PAGE_BARE = `${STATUS_PAGE} min-h-svh`;

/** Status disc above the title: the destructive tone on its soft tint. */
export const STATUS_DISC =
  'flex h-16 w-16 items-center justify-center rounded-full bg-[var(--color-danger-soft)] text-[var(--color-destructive-text)]';

/** Status disc for a page that is missing rather than refused: the info tone on its soft tint. */
export const STATUS_DISC_INFO =
  'flex h-16 w-16 items-center justify-center rounded-full bg-[var(--color-info-soft)] text-[var(--color-info)]';

/** Page title: GMDS 24/400. */
export const STATUS_TITLE = 'text-2xl font-normal text-[var(--color-foreground)]';

/** The one line of explanation under the title. */
export const STATUS_BODY = 'max-w-md text-sm text-[var(--color-muted-foreground)]';

/** The row of actions under the body. */
export const STATUS_ACTIONS = 'flex items-center gap-3';

/** The page's action: the kit's GMDS primary button (hover, pressed and focus states included). */
export const STATUS_ACTION = buttonVariants({ variant: 'primary', className: 'coarse:min-h-10' });

/** A quieter way back home beside the action. */
export const STATUS_HOME_LINK =
  'rounded-[var(--radius-control)] text-sm text-[var(--color-link)] underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-ring)] coarse:py-2.5';
